import { graphql, useStaticQuery } from 'gatsby'
import { useContext } from 'react'

import { LocaleContext, MeasurLocale } from '../locale/i18n'
import { Product } from '../logic/catalog'

const useProducts = () => {
  const { locale } = useContext(LocaleContext)

  return useStaticQuery<{
    allProduct: { nodes: { locale: MeasurLocale; productData: Product }[] }
  }>(graphql`
    query {
      allProduct {
        nodes {
          locale
          productData {
            accreditation
            contactFormInstructions
            description
            descriptionRaw
            detectionLimit
            deviceTypes {
              deviceTypeId
              parentDeviceTypeId
              nameLong
              nameShort
            }
            employeeId
            estimatedPrice {
              maxCents {
                EUR
                GBP
                USD
              }
              minCents {
                EUR
                GBP
                USD
              }
            }
            fixedPrice {
              firstSampleCents {
                EUR
                GBP
                USD
              }
            }
            id
            industryOrMaterial
            metaDescription
            metaTitle
            name
            owner {
              email
              name
            }
            parameters {
              helperText
              id
              slug
              options {
                id
                displayName
                priceDeltaCents {
                  EUR
                  GBP
                  USD
                }
              }
              priceScope
              title
            }
            pipedriveProductId
            popularityRank
            qualitySystems
            sampleRequirements
            slug
            standards {
              code
              group
              id
              slug
            }
            suitableSampleMaterials
            tatParameter {
              helperText
              id
              slug
              options {
                id
                displayName
                priceDeltaCents {
                  EUR
                  GBP
                  USD
                }
                turnaroundWeeks {
                  max
                  min
                }
              }
              priceScope
              title
            }
            turnaroundWeeks {
              max
              min
            }
            typeOfTesting
            webshopEnabled
            websitePricingModel
          }
        }
      }
    }
  `)
    .allProduct.nodes.filter(p => p.locale === locale)
    .map(({ productData }) => productData)
}

export default useProducts
